@let optimizerSettings = optimizerSettings$ | async;
<ng-container>
  <nz-drawer
    [nzVisible]="true"
    [nzMask]="true"
    [nzMaskClosable]="true"
    [nzMaskStyle]="{ backgroundColor: 'transparent' }"
    nzPlacement="right"
    [nzTitle]="
      'page.shift_timeline.assignment_optimizer.settings.algorithm_settings.label'
        | translate
    "
    [nzClosable]="true"
    [nzFooter]="drawerFooter"
    (nzOnClose)="
      assignAllShiftsButtonService.renderAssignmentOptimizerDrawer(false)
    "
  >
    <ng-container *nzDrawerContent>
      @if (loadingSignal()) {
        <nz-skeleton
          [nzActive]="true"
          [nzParagraph]="{ rows: 14 }"
        ></nz-skeleton>
      } @else {
        <wilson-assignment-optimizer-form
          [optimizerSettings]="optimizerSettings"
          (updateFormOutput)="updateIsSelectedStateOfSettings($event)"
        ></wilson-assignment-optimizer-form>
      }
    </ng-container>

    <ng-template #drawerFooter>
      <div class="drawer__footer">
        <wilson-last-update-status
          [updatedAt]="updatedAt()"
          [isUpdated]="isSuccessfullySaved()"
        ></wilson-last-update-status>
      </div>
    </ng-template>
  </nz-drawer>
</ng-container>
